//NOTE autogenerated by export script
export {APIKeysService as APIKeys} from './aPIKeys.service'
export {AccountAndPreferencesService as AccountAndPreferences} from './accountAndPreferences.service'
export {AnimalsService as Animals} from './animals.service'
export {CamerasService as Cameras} from './cameras.service'
export {CollarsService as Collars} from './collars.service'
export {ConfigurationDevicesService as ConfigurationDevices} from './configurationDevices.service'
export {DataLoggersService as DataLoggers} from './dataLoggers.service'
export {DeploymentsService as Deployments} from './deployments.service'
export {DropOffsService as DropOffs} from './dropOffs.service'
export {ESRIIdentityService as ESRIIdentity} from './eSRIIdentity.service'
export {ExternalSensorsService as ExternalSensors} from './externalSensors.service'
export {JSONLogsService as JSONLogs} from './jSONLogs.service'
export {ReportIssuesService as ReportIssues} from './reportIssues.service'
export {StoredFiltersService as StoredFilters} from './storedFilters.service'
export {TT4SensorsService as TT4Sensors} from './tT4Sensors.service'
export {TrapsService as Traps} from './traps.service'
export {VirtualFenceAPIService as VirtualFence} from './virtualFenceAPI.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {ItemsServices as Items} from './itemsService'
export {AllServices as All} from './allService'